<template>
  <div>

        <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      style="box-shadow: 0px 2px 20px 0px #105c8e26"
      class="bg-white p-10 rounded"
    >


     
 <h3 class="text-lg font-semibold text-blues mb-2">Bulk Upload Form</h3>

      <form @submit.prevent="handleSubmitcsv" class="space-y-4" ref="clearRef">
     
        <div class="flex flex-col gap-3 w-full">
          <div class="flex justify-between">
            <label for="attachments" class="text-left flex items-center"
              >Bulk Upload *
              <div class="relative group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <div
                  class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                >
                  Only CSV files in the sample format are allowed.
                </div>
              </div>
            </label>
            <div class="w-[20%] flex justify-center items-center">
              <a
                href="https://al-lms-api.galecta.com/media/bulk_upload.csv"
                download
                class="w-full flex gap-1 items-center justify-center tooltip"
              >
                <img
                  src="@/assets/newd/download.png"
                  alt="download file"
                  class="w-4 h-4 object-contain"
                />
                <span class="tooltiptext text-xs w-full"> Sample File</span>
              </a>
            </div>
          </div>
          <input
            id="source"
            type="file"
            class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
            @change="inputchange"
            
          />
        </div>

        <div class="flex justify-end">
          <button
            type="submit"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>

    </div>

    <div class="mt-10 overflow-x-auto">
      <h2 class="text-lg font-semibold mb-4">Submitted Data</h2>
      <table class="min-w-full divide-y divide-gray-200 border">
        <thead class="bg-blues">
          <tr>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              S.NO
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              First Name
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Last Name
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Email
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Mobile
            </th>
            <th class="px-4 py-2 text-left text-sm font-bold text-white">
              Role
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 bg-white">
          <tr v-for="(item, index) in submittedData" :key="index">
            <td class="px-4 py-2 text-sm">{{ (currentPage - 1) * 10 + index + 1 }}</td>
            <td class="px-4 py-2 text-sm">{{ item.first_name }}</td>
            <td class="px-4 py-2 text-sm">{{ item.last_name }}</td>
            <td class="px-4 py-2 text-sm">{{ item.email || "Na" }}</td>
            <td class="px-4 py-2 text-sm">
               {{ item.phone_number || "Na" }}
            </td>
            <td class="px-4 py-2 text-sm">{{ item.role||"Na" }}</td>
          </tr>
        </tbody>
      </table>

       <div
                class="pb-5 flex items-center justify-center"
              >
                <Pagination :totalPages="totalPages" @page-changed="getsubmit" />
               </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import phoneLength from "@/mixins/phoneLength";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";


export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      countryCode: "+91",
      phone_max_length: "",
      mobile: "",
      passwordOption: "custom",
      password: "",
      role: "",
      max_length: 10,
      rols: [],
      submittedData:[],
      totalPages: 0, 
      messages: {
        text: "",
        type: "null",
      },
       currentPage: 1,
    };
  },

  components: {
    FlashMessage,
    Pagination,
  },

  mixins: [countryCodeMixins, phoneLength],
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.password = this.generatePassword();
      } else {
        this.password = "";
      }
    },
  },
  computed: mapGetters(["userInfo"]),
  async created() {
    this.getrole();
    this.getsubmit(1);
  },
  mounted() {},
  methods: {

    handleSubmitcsv(el){

      let formData = new FormData();
      // formData.append("title", el.target.elements.file_title.value);
      // formData.append("description", el.target.elements.file_description.value);
      formData.append("file", el.target.elements.source.files[0]);
      // https://al-lms-api.galecta.com/media/bulk_upload.csv
      axios
        .post(
          `${process.env.VUE_APP_API}/enrollement-bulk-csv-upload/new/?Key=${this.userInfo.token_key}`,
          formData
        )
        .then((response) => {
          if (response.data.status == 200) {
                 this.getsubmit(1);
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.clearRef.reset();
            }, 1500);
         
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    getrole() {
      axios
        .get(
          `${process.env.VUE_APP_API}/permission-list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.rols = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSubmit() {
      const beforeData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        custom_password: this.password,
        auto_generative_password: this.password,
        country_code: this.countryCode,
        phone_number: this.countryCode + " " + this.mobile,
        role: this.role,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/user/signup/?Key=${this.userInfo.token_key}`,
          beforeData
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };

              this.getsubmit(1);
              this.$refs.addRefs.reset();

                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.password = "";
                this.password = "";
                this.countryCode = "";
                this.countryCode = "";
                this.mobile = "";
                this.role = "";
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
    getsubmit(number) {
       this.currentPage = number;
      axios
        .get(
          `${process.env.VUE_APP_API}/staff-enrollment-list/?Key=${this.userInfo.token_key}&page=${number}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
             this.totalPages = response.data.total_page;
            this.submittedData = response.data.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* tool tip  */
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40%;
  /* background-color: #17469E; */
  /* color: #fff; */
  color: #17469e;
  text-align: center;
  border: 1px solid #17469e;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  bottom: -8px;
  left: 20px;
  z-index: 1;
}
.wrapper-class {
  max-width: 200px;
  word-wrap: break-word;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
